module.exports = __webpack_public_path__ + "img/n3.973a42b7.jpeg";